import axios from 'axios'
import config from 'config'
import ApplicationPortal from 'state/enums/ApplicationPortal'

import { defaultLosJsonHeaders } from '../requestHeaders'

export interface PortalCopyResult {
    sourceApplicationId: number
    copiedApplicationId: number
    copiedApplicationUuid: string
    dealerWebAppUrl: string
    redirectUrl: string
}

export default async function postPortalCopy(
    applicationUuid: string,
    targetPortal: ApplicationPortal,
): Promise<PortalCopyResult> {
    const response = await axios.post<PortalCopyResult>(
        `${config.API_BASE_URL}/api/v3/applications/${applicationUuid}/portal-copy/`,
        { targetPortal },
        {
            withCredentials: true,
            headers: defaultLosJsonHeaders(),
        },
    )

    return response.data
}
